import {CostTranshipmentParams} from "@/modules/receiptsexpenses/updatecosttranshipment/params";
import http from "@/shared/services/http";

export const listCostTranshipment = (params: CostTranshipmentParams) => http.get("v1/cost-transhipments", {params})
export const scanCostTranshipment = (code) => http.get(`v1/picking-list-transhipments/scan/${code}`)
export const createCostTranshipment = (data) => http.post("v1/cost-transhipments", data)
export const singleCostTranshipment = (id) => http.get(`v1/cost-transhipments/${id}`)
export const updateCostTranshipment = (data) => http.put(`v1/cost-transhipments/${data.id}`, data)
